import { useQuery } from "@tanstack/react-query";
import { fetchEdiExtractHistory } from "../../../utils/apiUtils";

const STATUS_LABELS = {
    running: "Running",
    succeeded: "Success",
    failed: "Failed",
    timed_out: "Timed out",
    aborted: "Aborted",
};

const EdiExtractHistoryTable = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["edi-extract-history"],
        queryFn: fetchEdiExtractHistory,
        retry: false,
    });

    const executions = data?.executions || [];

    return (
        <div className="edi-extract-history">
            <p className="edi-extract-history__label">Recent runs</p>

            {isLoading && <p className="edi-extract-history__empty">Loading…</p>}
            {isError && <p className="edi-extract-history__empty">Couldn't load run history.</p>}
            {!isLoading && !isError && executions.length === 0 && (
                <p className="edi-extract-history__empty">No runs yet.</p>
            )}

            {!isLoading && !isError && executions.length > 0 && (
                <table className="edi-extract-history__table">
                    <thead>
                        <tr>
                            <th>Started</th>
                            <th>Status</th>
                            <th>Jobs</th>
                        </tr>
                    </thead>
                    <tbody>
                        {executions.map((exec) => (
                            <tr key={exec.executionArn}>
                                <td>{new Date(exec.startDate).toLocaleString()}</td>
                                <td>
                                    <span className={`edi-extract-history__pill ${exec.status}`}>
                                        {STATUS_LABELS[exec.status] || exec.status}
                                    </span>
                                </td>
                                <td>
                                    <div className="tags">
                                        {(exec.jobs || []).map((job) => (
                                            <span key={job} className="tag">{job}</span>
                                        ))}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default EdiExtractHistoryTable;
